var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 160,
    r: 160,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M320 160c0-63.43-36.92-118.24-90.43-144.12v288.25C283.09 278.25 320 223.44 320 160.01ZM0 160c0 63.43 36.92 118.24 90.43 144.12V15.88C36.91 41.76 0 96.57 0 160Zm187.83 20.87 27.82-13.91-13.91-6.96v-13.91L173.91 160l13.92-27.83h-13.92L160 111.3l-13.91 20.87h-13.92L146.09 160l-27.83-13.91V160l-13.91 6.96 27.82 13.91-6.95 13.91h27.82v20.87h13.92v-20.87h27.82l-6.95-13.91z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/Canada.42b0b271b33e501e2089f2de3af7636f.svg";
export { ForwardRef as ReactComponent };